
















































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import ReservationBulkListPreview from '@/modules/reservation/components/ReservationBulkListPreview.vue'
import DepartmentTypeSelect from '@/modules/reservation/components/DepartmentTypeSelect.vue'
import DepartmentInlineSelect from '@/modules/reservation/components/DepartmentInlineSelect.vue'
import {State} from 'vuex-class'
import BulkOptions from '@/modules/reservation/model/BulkOptions'
import Department from '@/modules/reservation/model/Department'
import {MutationTypes} from '@/modules/reservation/store/mutations'
import UserSelect from '@/modules/user/components/UserSelect.vue'
import EventSelect from '@/modules/reservation/components/EventSelect.vue'
import moment from 'moment'
import BulkProcess from '@/modules/reservation/components/BulkProcess.vue'

/**
 * Creador masivo de reservas
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        BulkProcess,
        ReservationBulkListPreview,
        DepartmentTypeSelect,
        DepartmentInlineSelect,
        UserSelect,
        EventSelect,
    },
})
export default class BulkReservationCreator extends Vue {
    public $refs: Vue['$refs'] & {
        form: {
            validate (): boolean
            resetValidation (): void,
        },

        preview: {
            loadPagination: () => Promise<void>,
        },
    }

    @State(state => state.reservation.bulkOptions)
    public bulkOptions: BulkOptions

    /**
     * Controla la visibilidad del selector de usuarios
     */
    public userSelect = false

    public hoursRange: any[] = []
    public calculatingHoursRange = false
    public allHours = false
    public selectedHours = []
    public valid = true
    public bulkProcess = false

    public get rules () {
        return {
            departmentType: [
                () => !!this.bulkOptions.departmentType.id || 'El tipo de departamento es obligatorio',
            ],
            departments: [
                () => !!this.bulkOptions.departments.length || 'Es necesario seleccionar al menos un departamento',
            ],
            user: [
                () => !!this.bulkOptions.user.id || 'El usuario es obligatorio',
            ],
            dateStart: [
                () => !!this.bulkOptions.dateStart || 'Es obligatorio seleccionar la fecha de inicio',
            ],
            dateEnd: [
                () => !!this.bulkOptions.dateEnd || 'Es obligatorio seleccionar la fecha de fin',
                () => {
                    const start = moment(this.bulkOptions.dateStart)
                    const end = moment(this.bulkOptions.dateEnd)

                    return (end.isAfter(start) || end.isSame(start)) || 'La fecha de fin debe ser igual o posterior a la fecha de inicio'
                },
            ],
            hours: [
                () => !!this.bulkOptions.hours.length || 'Es obligatorio seleccionar al menos una hora',
            ],
            event: [
                () => !!this.bulkOptions.event.id || 'Es obligatorio seleccionar un evento para las reservas',
            ],
        }
    }

    public async clear () {
        this.$store.commit('reservation/RESET_BULK_OPTIONS')
        this.$refs.form.resetValidation()
        await this.$store.dispatch('reservation/clearReservationBulkList')
    }

    public selectAllHours (select: boolean) {
        this.allHours = select
        if (!select) {
            this.updateBulkOption('hours', [])

            return
        }

        this.updateBulkOption('hours', this.hoursRange)
    }

    public async calculateHoursRange (departments: Department[]) {
        if (!departments.length) {
            return
        }

        this.hoursRange = await this.$store.dispatch('reservation/calculateDepartmentHours', {
            department: departments[0],
        })
    }

    /**
     * Actualiza un parámetro de las opciones para la creación masiva de reservas
     *
     * @param field
     * @param value
     */
    public updateBulkOption (field: string, value: any) {
        this.$store.commit(`reservation/${MutationTypes.UpdateBulkOption}`, {field, value})
    }

    public async generateBulkList () {
        if (!this.$refs.form.validate()) {
            return
        }

        await this.$store.dispatch('reservation/processBulkReservationList', this.bulkOptions)
        await this.$store.dispatch('reservation/loadReservationBulkList', {
            page: 1,
            recordsPerPage: 50,
        })
    }

    public async executeBulkProcess () {
        this.bulkProcess = true
        await this.$store.dispatch('reservation/executeReservationBulkProcess')
        await this.$refs.preview.loadPagination()
    }
}
